import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  outOfStock,
  cartError,
  productError,
  otherError,
  viewBasket,
  continueShopping,
  productMisconfiguration
} = translate({
  "outOfStock": "Product out of stock",
  "cartError": "The cart is no longer available",
  "productError": "The product is no longer available",
  "otherError": "An error has occurred",
  "viewBasket": "View basket",
  "continueShopping": "Continue shopping",
  "productMisconfiguration": "Ah, there's been a little error - the product has not successfully been added to your basket"
});
export const title = translateFormatter<{
  productsNumber: number;
}>("{productsNumber, plural, =0 {No products could be added} =1 {1 product has been added} other {# products have been added}}", undefined, undefined, "en");
export const titleLonger = translateFormatter<{
  productsNumber: number;
}>("{productsNumber, plural, =0 {No products could be added to your basket} =1 {1 product added to your basket} other {# products added to your basket}}", undefined, undefined, "en");